import { apiPostModel, postApi } from '../../useApiHook';

export const postAssignClinicianToTreatment = (auth, entityModel, callback, errorCallback) => {
  const postModel = apiPostModel('AssignClinicianToTreatmentInstance', entityModel, callback, errorCallback);
  postApi(auth, postModel);
};

export const postRescheduleClinicianAssignment = (auth, entityModel, callback, errorCallback) => {
  const postModel = apiPostModel('RescheduleClinicianAssignment', entityModel, callback, errorCallback);
  postApi(auth, postModel);
};

export const postUpdateLunchBreak = (auth, entityModel, callback, errorCallback) => {
  const postModel = apiPostModel('UpdateLunchBreak', entityModel, callback, errorCallback);
  postApi(auth, postModel);
};

export const postUnassignClinicianFromTreatmentInstance = (auth, entityModel, callback, errorCallback) => {
  const postModel = apiPostModel('UnassignClinicianFromTreatmentInstance', entityModel, callback, errorCallback);
  postApi(auth, postModel);
};

export const postUnassignClinicianFromNonPatientActivity = (auth, entityModel, callback, errorCallback) => {
  const postModel = apiPostModel('UnassignClinicianFromNonPatientActivity', entityModel, callback, errorCallback);
  postApi(auth, postModel);
};

export const createBundleTreatment = (auth, entityModel, callback, errorCallback) => {
  const postModel = apiPostModel('BundleTreatmentInstances', entityModel, callback, errorCallback);
  postApi(auth, postModel);
};

export const overrideBundleDuration = (auth, entityModel) => {
  const postModel = apiPostModel('OverrideBundleDuration', entityModel);
  postApi(auth, postModel);
};

export const postUnbundleTreatmentInstance = (auth, entityModel, errorCallback) => {
  const postModel = apiPostModel('UnbundleTreatmentInstances', entityModel, errorCallback);
  postApi(auth, postModel);
};

export const postAssignClinicianToMultipleTreatments = (auth, entityModel, callback, errorCallback) => {
  const postModel = apiPostModel('AssignClinicianToMultipleTreatmentInstances', entityModel, callback, errorCallback);
  postApi(auth, postModel);
};

export const editTreatmentInstanceNotes = (auth, entityModel, callback, errorCallback) => {
  const postModel = apiPostModel('EditTreatmentInstanceNotes', entityModel, callback, errorCallback);
  postApi(auth, postModel);
};

export const convertVisitToPhoneCall = (auth, entityModel, callback, errorCallback) => {
  const postModel = apiPostModel('ConvertTreatmentInstance', entityModel, callback, errorCallback);
  postApi(auth, postModel);
};
